(function () {
	'use strict';

	angular
		.module('app.setup')
		.controller('shortageRiskScoreConfig', shortageRiskScoreConfig);

	shortageRiskScoreConfig.$inject = ['$rootScope', '$scope', '$timeout', 'storeService'];

	function shortageRiskScoreConfig($rootScope, $scope, $timeout, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;

		vm.showAddRiskCategory = true;

		$scope.type = 'site';
		$scope.siteId = adminConfig.factory.id;
		$scope.customerId = adminConfig.customer.id;
		$scope.factoryName = adminConfig.factory.name;
	}
})();